<!-- Interactions -->
<div class="surface-0 border-1 border-300 shadow-1 border-round text-sm p-3 flex align-items-center justify-content-between" [attr.data-testid]="'migration-header'">
  <div [attr.data-testid]="'migration-date-section'">
    <div *ngIf="!(showSkeleton |async ) && clientMigration" [attr.aria-label]="'migration-date'" [innerHTML]="'MIGRATION.MIGRATION_DATE' | translate : {date: clientMigration.created_date | date: 'dd MMM yy' }">
    </div>
    <p-skeleton *ngIf="showSkeleton | async" height="1.5rem" styleClass="w-10rem" [attr.data-testid]="'migration-date-skeleton'"></p-skeleton>
  </div>
</div>
<!-- Interactions -->

<!-- Card -->
<div *ngIf="showSkeleton |async; else showdata" class="surface-0 p-3 border-1 border-300 shadow-1 border-round text-sm mt-3" [attr.data-testid]="'migration-content-skeleton'">
</div>

<ng-template #showdata>
  <div *ngIf="clientMigration && clientMigration!.migration_comments; else noData" class="surface-0 p-3 border-1 border-300 shadow-1 border-round text-sm mt-3" [attr.data-testid]="'migration-content'" [attr.aria-label]="'migration-comments'" [innerHTML]="clientMigration!.migration_comments | markdown">
  </div>
  <ng-template #noData>
   <div #noDate class="surface-0 h-23rem border-1 border-300 shadow-1 border-round text-sm mt-3" [attr.data-testid]="'migration-no-data'" [attr.aria-label]="'no-migration-data'"></div>
  </ng-template>
</ng-template>

<!-- Card -->

